import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import styles from "./LocationEnvironment.module.scss";
import Header from "../../components/Header/Header";
import MenuBar from "../../components/MenuBar/MenuBar";
import Footer from "../../components/Footer/Footer";
import Bener from "../../components/Bener/Bener";
import FixIcon from "../../components/FixIcon/FixIcon";
import LocationSectionBox from "../../components/LocationSectionBox/LocationSectionBox";
import { Helmet } from "react-helmet-async";

import page1 from "../../assets/LocationEnvironment/LocationEnvironment1/page1.jpg";
import section2Image1 from "../../assets/LocationEnvironment/LocationEnvironment1/session2-1.jpg";
import section2Image2 from "../../assets/LocationEnvironment/LocationEnvironment1/session2-2.jpg";
import section2Image3 from "../../assets/LocationEnvironment/LocationEnvironment1/session2-3.jpg";
import section2Image4 from "../../assets/LocationEnvironment/LocationEnvironment1/session2-4.jpg";
import section2Image5 from "../../assets/LocationEnvironment/LocationEnvironment1/session2-5.jpg";
import section2Image6 from "../../assets/LocationEnvironment/LocationEnvironment1/session2-6.jpg";
import HelmetCOM from "../../components/HelmetCOM/HelmetCOM";

const LocationSection = [
  {
    img: section2Image1,
    titleText: "평택 화양지구 개발 중심<br />높아지는 미래가치",
    contentText:
      "평택 서부권 핵심 개발지 화양지구 중심 입지<br />주거·상업·교육·공원시설 계획된 도시개발지구",
  },
  {
    img: section2Image2,
    titleText: "서평택 생활 인프라 중심<br />편리한 생활 환경",
    contentText:
      "안중 생활권 인접으로 생활 편의시설 이용 편리<br />병원·마트·금융시설 등 생활 인프라 확보",
  },
  {
    img: section2Image3,
    titleText: "서해안 교통망 접근성<br />수도권 이동 편리",
    contentText:
      "서해안고속도로·평택제천고속도로 이용 편리<br />평택항·포승국가산단 등 산업벨트 접근성",
  },
  {
    img: section2Image4,
    titleText: "확장되는 생활 인프라<br />서평택 중심 생활권",
    contentText:
      "안중 중심 상권 이용 가능한 생활 환경<br />주거와 생활이 함께 성장하는 화양지구",
  },
  {
    img: section2Image5,
    titleText: "화양지구 주거 프리미엄<br />서희스타힐스 브랜드",
    contentText:
      "쾌적한 단지 설계와 효율적인 평면 구성<br />서희스타힐스 브랜드 주거 가치",
  },
  {
    img: section2Image6,
    titleText: "자연과 어우러진 주거환경<br />쾌적한 생활 공간",
    contentText:
      "공원과 녹지가 어우러진 쾌적한 주거 환경<br />여유로운 일상을 위한 주거 공간",
  },
];





const LocationEnvironment1 = () => {
  const menuContents = [
    // { title: "입지 안내영상", url: "/FloorPlan/videos" },
    { title: "입지안내", url: "/LocationEnvironment/intro" },
    { title: "프리미엄", url: "/LocationEnvironment/primium" },
  ];
  const [isScroll, setIsScroll] = useState(false);
  const { pathname } = useLocation(); // 현재 경로를 가져옴

  useEffect(() => {
    window.scrollTo(0, 0); // 페이지가 로드될 때 스크롤을 최상단으로 이동
  }, [pathname]); // pathname이 변경될 때마다 실행

  // 화면 스크롤이 탑이 아니면 isScroll 값 true로 변환
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScroll(true);
      } else {
        setIsScroll(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={styles.container}>
<Helmet>
  {/* 페이지별 메타: title/description/og/canonical 만 관리 */}
  <title>평택 화양 서희스타힐스 - 입지환경</title>
  <meta
    name="description"
    content="평택 화양 서희스타힐스 입지환경 안내. 평택 화양지구 중심 입지와 서해안고속도로 교통망, 안중 생활 인프라와 서평택 개발 미래가치를 확인하세요."
  />
  <meta name="robots" content="index,follow" />
  <link rel="canonical" href="https://www.leecols.kr/LocationEnvironment/intro" />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="평택 화양 서희스타힐스" />
  <meta property="og:title" content="평택 화양 서희스타힐스 - 입지환경" />
  <meta
    property="og:description"
    content="평택 화양지구 중심 입지와 교통망, 생활 인프라를 확인할 수 있는 평택 화양 서희스타힐스 입지환경 안내."
  />
  <meta property="og:url" content="https://www.leecols.kr/LocationEnvironment/intro" />
  <meta property="og:image" content="https://www.leecols.kr/img/og/location.jpg" />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="630" />

  {/* Twitter */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="평택 화양 서희스타힐스 - 입지환경" />
  <meta
    name="twitter:description"
    content="평택 화양지구 중심 입지와 교통·생활 인프라를 확인할 수 있는 평택 화양 서희스타힐스 입지환경."
  />
  <meta name="twitter:image" content="https://www.leecols.kr/img/og/location.jpg" />
  <meta name="twitter:url" content="https://www.leecols.kr/LocationEnvironment/intro" />

  {/* JSON-LD */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "평택 화양 서희스타힐스 - 입지환경",
      "url": "https://www.leecols.kr/LocationEnvironment/intro",
      "description":
        "평택 화양지구 중심 입지와 교통망, 생활 인프라를 확인할 수 있는 평택 화양 서희스타힐스 입지환경 안내 페이지입니다.",
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "contentUrl": "https://www.leecols.kr/img/og/location.jpg",
        "width": 1200,
        "height": 630
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "홈", "item": "https://www.leecols.kr/" },
          { "@type": "ListItem", "position": 2, "name": "입지환경", "item": "https://www.leecols.kr/LocationEnvironment/intro" }
        ]
      }
    })}
  </script>
</Helmet>

<Header isChanged={isScroll} />
<FixIcon />

<Bener title="입지환경" />

<MenuBar contents={menuContents} />

<h1 className={styles.screenReaderOnly}>
  평택 화양 서희스타힐스 입지환경
</h1>
<p className={styles.screenReaderOnly}>
  평택 화양 서희스타힐스의 입지 정보를 확인하세요. 평택 화양지구 중심 입지와
  서해안고속도로 교통망, 안중 생활권 인프라와 서평택 개발 미래가치를 갖춘
  주거 환경을 소개합니다.
</p>

<div className={styles.textBox}>
  <div>화양지구의 새로운 중심</div>
  <div>삶의 가치가 높아지는 곳</div>
  <div>평택 화양 서희스타힐스</div>
</div>

<img
  src={page1}
  className={styles.image2}
  alt="평택 화양 서희스타힐스 입지환경 안내"
/>

      <div className={styles.section2}>
        {LocationSection.map((value, idx) => (
          <LocationSectionBox
            image={value.img}
            title={value.titleText}
            text={value.contentText}
          />
        ))}
      </div>

      <div className={styles.commonBox}>
        <div className={styles.notice}>
          ※본 홍보물의 내용과 지역도는 소비자의 이해를 돕기 위한 것으로, 개발 예정•계획 및 교통, 학교 계획 등에 관한 사항은 해당 기관의 아래 자료를 토대로 제작되었습니다. 사업계획 및 일정은 개발계획별 사업주체에 의해 변경될 수 있으며, 평택 화양 서희스타힐스사업주체 및 시공사와 무관합니다.
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LocationEnvironment1;
